import ReportSidebar from '../ReportSidebar.jsx';
import ReportSectionRenderer from '../ReportSectionRenderer.jsx';
import { useReportTemplateContext } from './ReportTemplateContext.js';

const ReportTemplateView = ({ loading, error }) => {
  const {
    report,
  } = useReportTemplateContext();

  // if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-danger">Error: {error.message}</div>;

  return (
    <div className="d-flex flex-column flex-md-row" style={{ minHeight: '100vh' }}>
      {report && (
        <div
          className="bg-white border-bottom border-md-end"
          style={{ width: '100%', maxWidth: 238, flexShrink: 0 }}
        >
          <ReportSidebar />
        </div>
      )}

      <div
        className="flex-grow-1 report-main-content"
        style={{
          backgroundColor: '#f8f9fa',
          padding: 'clamp(0.25rem, 2vw, 1rem)',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          zoom: 0.85,
        }}
      >
        <div className="report-width-container">
          <ReportSectionRenderer/>
        </div>
      </div>
    </div>
  );
};

export default ReportTemplateView;
